import { Navigate, useNavigate } from "react-router-dom";

import Button from "./Button";

const ageLabels = {
  puppy: "Puppy|0–1 year",
  young: "Young Adult|1–3 years",
  adult: "Adult|3–7 years",
  senior: "Senior|7–10+ years",
  geriatric: "Geriatric|10+ years",
};

const sizeLabels = {
  small: "Small|Up to 10 kg (22 lbs)",
  medium: "Medium|10–25 kg (22–55 lbs)",
  large: "Large|Over 25 kg (55 lbs)",
};

const staticUrl: string = process.env.STATIC_URL;

type PetHeaderProps = {
  pet: { [k: string]: string };
  showMore?: boolean;
  children?: React.ReactNode;
};

export default function PetHeader({ pet, children, showMore }: PetHeaderProps) {
  const navigate = useNavigate();

  const renderGenderIcon = () => {
    if (pet.gender === "female") {
      return (
        <div className="rounded-[4px] bg-theme-amber-5 p-[4px] text-[12px] font-semibold leading-none text-theme-white">
          Female
        </div>
      );
    } else {
      return (
        <div className="rounded-[4px] bg-theme-purple-5 p-[4px] text-[12px] font-semibold leading-none text-theme-white">
          Male
        </div>
      );
    }
  };

  const renderMainImage = () => {
    const i = pet.images.find((im) => im.main === true);

    const src = i ? i.url : pet.images[0].url;

    return <img className="w-[225px] rounded-[4px]" src={`${staticUrl}${src}`} alt={pet.name} />;
  };

  const renderBreed = () => {
    const breedList = [];
    if (pet.breed) {
      breedList.push(pet.breed);
    }
    if (pet.breedAdditional) {
      breedList.push([...pet.breedAdditional]);
    }
    return breedList.length > 0 ? breedList.join(", ") : "";
  };

  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-row gap-6">
        {renderMainImage()}
        <div className="flex flex-col justify-between">
          <div>
            <div className="flex">
              <div className="text-[64px] font-medium leading-[1.05]">{pet.name}</div>{" "}
              <div>{renderGenderIcon()}</div>
            </div>
            <div className="text-[24px] font-semibold text-theme-grey-11">{renderBreed()}</div>
            <div className="flex gap-2 text-[20px] text-theme-grey-11">
              <span className="font-semibold">{ageLabels[pet.age]?.split("|")[0]}</span>
              <span className="">{ageLabels[pet.age]?.split("|")[1]}</span>
              <span className="font-semibold">{sizeLabels[pet.size]?.split("|")[0]}</span>
              <span className="">{sizeLabels[pet.size]?.split("|")[1]}</span>
            </div>
          </div>
          {showMore && (
            <div>
              <Button
                title="Show more"
                theme="secondary"
                onClick={() => navigate(`/pet/${pet.id}`)}
              />
            </div>
          )}
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
}
